import { ConnectwareError, type RuleEngineEndpoint, RuleEngineType, selectSandbox } from '../../../domain'

import { BaseSandboxUsecase } from './Base'

export class FilterSandboxUsecase extends BaseSandboxUsecase {
    selectType (type: RuleEngineType): void {
        const { input } = selectSandbox(this.getState())

        this.setSandbox({
            type,

            endpointsSearch: '',
            endpoints: null,
            /** Clear the endpoint selection */
            selectedEndpoints: type === RuleEngineType.ENDPOINT ? [] : null,

            /** De-select all topics */
            selectedTopics: null,

            /**
             * Reset input
             * if the new type is json, attempt to migrate from previous value, or set empty object
             * otherwise, just nullify it as unloaded
             */
            input: type === RuleEngineType.JSON
                ? { loaded: true, topic: null, value: ConnectwareError.is(input.value) || input.value === null ? {} : input.value }
                : { loaded: false, topic: null, value: null },
        })
    }

    setJson (json: unknown): void {
        this.setSandbox({
            type: RuleEngineType.JSON,

            selectedEndpoints: null,
            endpointsSearch: '',
            endpoints: null,

            selectedTopics: null,
            input: { loaded: true, topic: null, value: json },
        })
    }

    setEndpointsSearch (endpointsSearch: string): void {
        this.setSandbox({ endpointsSearch, endpoints: null })
    }

    selectEndpoints (selectedEndpoints: readonly RuleEngineEndpoint[]): void {
        const { input } = selectSandbox(this.getState())
        const selectedTopics = new Set(selectedEndpoints.flatMap((e) => e.topics))
        const isRelevant = input.loaded && input.topic !== null && selectedTopics.has(input.topic)

        this.setSandbox({
            selectedEndpoints,
            selectedTopics: Array.from(selectedTopics),
            input: isRelevant ? input : { loaded: false, topic: null, value: null },
        })
    }

    selectTopics (selectedTopics: readonly string[]): void {
        this.setSandbox({ selectedTopics })
    }

    setTransformation (transformation: string): void {
        this.setSandbox({ transformation })
    }
}
